import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import workerScript from '../sterilwize/Cases/worker';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class TimestampService {
  private timestampSubject = new BehaviorSubject<number | null>(null);
  public timestamp$ = this.timestampSubject.asObservable();

  private _hasFetched = false;
  private worker: Worker | undefined;

  setTimestamp(timestamp: number) {
    this.timestampSubject.next(timestamp);
    this._hasFetched = true;
  }

  getTimestamp(): number | null {
    return this.timestampSubject.getValue();
  }

  hasFetched(): boolean {
    return this._hasFetched;
  }

  initLocalTimestamp(timezone: string = 'UTC') {
    const localNow = new Date();
    const labTime = moment.tz(localNow, timezone);
    this.setTimestamp(labTime.valueOf());
  }

  initWorker() {
    if (typeof Worker !== 'undefined' && !this.worker) {
      this.worker = new Worker(workerScript);

      this.worker.onmessage = ({ data }) => {
        if (data.type === 'tick' && data.label === 'startWatch') {
          const current = this.timestampSubject.getValue();
          if (current != null) {
            this.timestampSubject.next(current + 1000);
          }
        }
      };

      this.worker.postMessage({
        type: 'start',
        label: 'startWatch',
        delay: 1000
      });
    }
  }

  stopWorker() {
    if (this.worker) {
      this.worker.terminate();
      this.worker = undefined;
    }
  }
}
